const APP_VERSION = '1767812858097';
export default APP_VERSION;
